import { useMemo } from 'react';
import { useRouter } from 'shared-routing';
import { CATEGORY_ROUTES } from './constants';

const routeToCategory = Object.entries(CATEGORY_ROUTES).reduce<Record<string, string>>(
  (acc, [id, route]) => {
    acc[route] = id;
    return acc;
  },
  {}
);

export function useCurrentCategory(): string | undefined {
  const router = useRouter();

  return useMemo(() => routeToCategory[router.pathname], [router.pathname]);
}
